import { http_api } from "../../leadg-api";
// Item #9 — Revenue Attribution admin screen. Server-side search/sort/paging; `config` carries the
// AbortSignal from useDebouncedFetch so superseded searches are cancelled rather than racing.
const search = (request, config) => {
    let url = `revenue-attribution/search?page=${request.page}&pageSize=${request.pageSize}`;
    if (request.search)
        url += `&search=${encodeURIComponent(request.search)}`;
    if (request.sortField)
        url += `&sortField=${encodeURIComponent(request.sortField)}`;
    if (request.sortOrder)
        url += `&sortOrder=${request.sortOrder}`;
    // Guard against 0/null: SentBySource starts at 1, so a falsy value means "no filter".
    if (request.sentBySource)
        url += `&sentBySource=${request.sentBySource}`;
    // Only sent when true — the server treats a missing value as "no filter".
    if (request.onlyUnattributed)
        url += `&onlyUnattributed=true`;
    if (request.needsReview)
        url += `&needsReview=true`;
    return http_api.get(url, config);
};
const getByContractId = (contractId) => {
    return http_api.get(`revenue-attribution/${contractId}`);
};
// Returns the refreshed row, so the caller updates from the server's truth rather than
// optimistically assuming what it wrote.
const updateSentBy = (input) => {
    return http_api.put("revenue-attribution/sent-by", input);
};
const RevenueAttributionApi = {
    search,
    getByContractId,
    updateSentBy,
};
export default RevenueAttributionApi;
